import React from 'react';
import { DateCalendar as MUICalendarPicker, PickersDay } from '@mui/x-date-pickers';
import { DateObject } from '@uplift/services';

import { withStyles } from 'tss-react/mui';


const StyledMUICalendarPicker = withStyles(MUICalendarPicker, {
  root: {
    width: 'initial',
  },

  '& .MuiDayPicker-slideTransition': {
    minHeight: 200,
  }
});


const StyledMUIPickersDay = withStyles(PickersDay, (theme) => ({
  root: {
    width: '31px',
    height: '31px',

    '&.Mui-selected': {
      color: theme.palette.grey[800],
      fontWeight: 400,
      backgroundColor: theme.palette.secondary.border,
      '&:focus': {
        backgroundColor: theme.palette.secondary.border,
      },
      '&:hover': {
        backgroundColor: theme.palette.secondary.border,
      }
    },
  },

  dayOutsideMonth: {
    color: theme.palette.grey[500],
  },

}));


export type CalendarPickerProps = {
  date: DateObject;
  onDateSelect: (date: DateObject) => void;
  disablePast?: boolean;
  minDate?: DateObject;
  today?: DateObject;
  highlightCurrentDay?: boolean;
};


const TIMEZONE = 'Etc/UTC';

export const CalendarPicker: React.FC<CalendarPickerProps> = ({ disablePast, minDate, today: _today, date: _date, onDateSelect }) => {
  const date = React.useMemo(() => {
    return _date.tz(TIMEZONE, true).utc().startOf('date');
  }, [ _date ]);

  const onDateSelectRef = React.useRef(onDateSelect);

  onDateSelectRef.current = onDateSelect;

  return (
    <StyledMUICalendarPicker
      dayOfWeekFormatter={day => day.format('dd')}
      views={[ 'day' ]}
      disablePast={disablePast}
      minDate={minDate}
      value={date}
      onChange={(value) => {
        onDateSelectRef.current?.(value as any);
      }}
      showDaysOutsideCurrentMonth
      slots={{
        day: StyledMUIPickersDay
      }}
    />
  );
};
